import React, { FC, useEffect, useState, } from "react";
import { Accordion, AccordionSummary, Grid, Paper } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { trafficLight } from "../../theme";
import { calculateNewValue } from "@testing-library/user-event/dist/utils";

interface IFMChartProps {
    data: boolean
}

const Loading: FC<IFMChartProps> = ({ data }) => {

    const [load, setLoad] = useState<String>(".");

    useEffect(() => {

        let index = 1
        let intervalID = setInterval(() => {

            if (index === 4) {
                index = 0
            }

            index++
            setLoad(".".repeat(index))

        }, 500);


        return () => { clearInterval(intervalID) }
    }, []);

    return (
        <>
            <div style={{position:'fixed',left:'calc(50% - 125px)'}}>Fetching Data {load}</div>
        </>)
}


export default Loading;